"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BucketNames = void 0;
// (C) 2007-2020 GoodData Corporation
var MEASURES = "measures";
var SECONDARY_MEASURES = "secondary_measures";
var TERTIARY_MEASURES = "tertiary_measures";
var ATTRIBUTE = "attribute";
var ATTRIBUTES = "attributes";
var VIEW = "view";
var STACK = "stack";
var TREND = "trend";
var SEGMENT = "segment";
var COLUMNS = "columns";
var LOCATION = "location";
var SIZE = "size";
var COLOR = "color";
var TOOLTIP_TEXT = "tooltipText";
/**
 * Standard bucket names used in the different visualizations.
 * @internal
 */
exports.BucketNames = {
    MEASURES: MEASURES,
    SECONDARY_MEASURES: SECONDARY_MEASURES,
    TERTIARY_MEASURES: TERTIARY_MEASURES,
    ATTRIBUTE: ATTRIBUTE,
    ATTRIBUTES: ATTRIBUTES,
    VIEW: VIEW,
    STACK: STACK,
    TREND: TREND,
    SEGMENT: SEGMENT,
    COLUMNS: COLUMNS,
    LOCATION: LOCATION,
    SIZE: SIZE,
    COLOR: COLOR,
    TOOLTIP_TEXT: TOOLTIP_TEXT,
};
//# sourceMappingURL=bucketNames.js.map